import React, {useEffect, useState} from "react";
import helpers from "@src/../js/helpers";
import useHeaderMenuStore from "@src/stores/HeaderMenuStore";


export function HeaderActionCurrency({ settings, isMobile }) {

    const { section, blocks } = settings;
    const [currencyCode, setCurrencyCode] = useState('');
    const text_style = section.header_font_type;

    useEffect(() => {
        window.addEventListener('currency_initialised' , (event) => {
            setCurrencyCode(event.detail.currency.name);
        });
    }, []);

    const openMenu = useHeaderMenuStore((state) => state.openMenu)
    const currencyBlock = blocks?.find(block => block.type === "currency_selector");

    return (
        <>
            {section.show_currency_in_header && !isMobile && (
                <div
                    className={`header-action__link ${text_style} cursor-pointer`}
                    // x-on:mouseenter="$store.global.toggleCurrencyMenu()"
                    onMouseEnter={() => {
                        if (currencyBlock?.settings?.show_currency_in_header_no_dropdown) {
                            openMenu("CURRENCY");
                        }
                    }}
                >
                    {currencyCode}
                </div>
            )}
        </>
    );
}
